import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';
import DropDownOption from '../../dropDownOption/dropDownOption';
import TooltipOnEllipsis from '../../tooltipOnEllipsis/tooltipOnEllipsis';
import Illustration from '../../illustration/illustration';
var DropDownIllustrationOption = function DropDownIllustrationOption(props) {
  var label = props.label;
  return /*#__PURE__*/React.createElement(DropDownOption, _.assign({}, {
    className: 'dropdown-illustration-option',
    forceChildren: true
  }, _.omit(props, 'children')), /*#__PURE__*/React.createElement("div", {
    className: props.label ? 'dropdown-illustration-option-preview' : 'dropdown-illustration-option-preview dropdown-illustration-only',
    key: "thumbnailPreview"
  }, /*#__PURE__*/React.createElement(Illustration, null, props.children), label && /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
    marginTop: -10,
    closeOnMouseClick: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-illustration-option-label"
  }, label))));
};
DropDownIllustrationOption.displayName = displayNames.DROP_DOWN_ILLUSTRATION_OPTION;
DropDownIllustrationOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  wasVisible: PropTypes.bool,
  wasVisibleStyle: PropTypes.object,
  selectedValueSuffix: PropTypes.node
};
export default compose(DropDownIllustrationOption);